const BlogContent = [
    {
        images: '01',
        title: 'Security-First Development',
        category: 'Engineering'
    },
    {
        images: '02',
        title: 'Clean, Maintainable Codebases',
        category: 'Best Practices'
    },

    {
        images: '03',
        title: 'Performance-Optimized Frontends',
        category: 'Architecture'
    },
    // {
    //     images: '04',
    //     title: ' Getting tickets to the big show',
    //     category: 'Development'
    // },
    // {
    //     images: '01',
    //     title: 'A big ticket gone to be an interesting ',
    //     category: 'Management'
    // },
    // {
    //     images: '02',
    //     title: 'The Home of the Future Could Bebes',
    //     category: 'Design'
    // },
]

export default BlogContent;